module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"choose format":"Choose format","portrait":"Portrait","landscape":"Landscape","copyright":"Copyright ©2020 touchwert®<br>touchwert® is a registered trademark of bestzoom GmbH<br>touchwert creator V2.0"}}')
  delete Component.options._Ctor
}
